import { checkResult } from '@/utils/tools'
import { buildUinfos } from './useBuildUinfos'
import { useRequest } from 'vue-request'
import { message } from 'ant-design-vue'
import request from '@/utils/request'
import { API_BASE } from '@Con'
import useSwitchRole from '@com/auth/useSwitchRole'

export default (auth) => {
  // 切换登录机构 - 默认取初始 account 以及 默认 role
  const {
    data: result,
    runAsync,
    loading
  } = useRequest((payload) => request(API_BASE + '/myInfo/switchOrg', payload))

  const { switchAndBuildMenus } = useSwitchRole(auth)

  const switchOrg = async (orgId, jumpInFlag = true, tenantOrgId) => {
    await runAsync({ orgId, tenantOrgId })

    if (checkResult(result.value)) {
      if (jumpInFlag) {
        // 直接进入页面
        const payload = {
          accountId: result.value.data.accounts[0].accountId,
          roleId: result.value.data.accounts[0].roles[0].roleId,
          tenantOrgId: result.value.data.accounts[0].tenantOrgId
        }
        return await switchAndBuildMenus(payload.accountId, payload.roleId, payload.tenantOrgId)
      } else {
        // 多角色用户，需要从登录页面进入个人中心选择
        buildUinfos(auth, result.value.data)
        return 2
      }
    } else {
      throw new Error(result.value.msg)
    }
  }

  return {
    loading,

    switchOrg
  }
}
